module.exports = __webpack_public_path__ + "static/logo-cf4e8edf8c39529bde2d31930cda3f23.png";